import React from 'react';
import {Box, Typography} from '@mui/material';
import {BuilderPot_dentistChildren} from '../../../schema-types/BuilderPot';
import {PlanAccordionShell} from '../CreateBuilder/BuilderSourceDestination/PlanAccordionShell';
import {PlanSelector} from '../CreateBuilder/BuilderSourceDestination/PlanSelector';
import {PlanValidationIcon} from '../CreateBuilder/BuilderSourceDestination/PlanValidationIcon';
import {getSubplanSummaryParts} from '../CreateBuilder/BuilderSourceDestination/builderNaming';
import {WithdrawalDetails} from './BuilderWithdrawalSources';
import {getCurrencyFloat} from '../../../utils/currencyFormatter';

interface WithdrawalSourceSubplanProps {
  subPlan: BuilderPot_dentistChildren;
  isSelected: boolean;
  handleChange: () => void;
}

export const WithdrawalSourceSubplan: React.FC<WithdrawalSourceSubplanProps> = ({
  subPlan,
  isSelected,
  handleChange,
}) => {
  const formikKeyPrefix = isSelected ? 'withdraw.source' : undefined;

  return (
    <Box
      id={subPlan.id}
      data-recc-id={subPlan.originalOvrId ?? 'New plan'}
      data-selected={isSelected ? 'selected' : 'not-selected'}
      data-is-subplan="true"
      data-test="choice-option"
    >
      <PlanAccordionShell
        expanded={isSelected}
        isSelected={isSelected}
        isSoleParent={false}
        flat
        compact
        validationLevel="nothing"
        summaryChildren={
          <>
            <PlanSelector
              mode="single"
              id={subPlan.id}
              isSelected={isSelected}
              handleChange={handleChange}
            />
            <Box
              display="flex"
              flex={1}
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="body2">
                {getSubplanSummaryParts(subPlan).label}
              </Typography>
              {getSubplanSummaryParts(subPlan).currentValue && (
                <Typography variant="body2" sx={{ml: 2, whiteSpace: 'nowrap'}}>
                  {getSubplanSummaryParts(subPlan).currentValue}
                </Typography>
              )}
            </Box>
          </>
        }
        summaryTrailing={
          formikKeyPrefix ? (
            <PlanValidationIcon formikKeyPrefix={formikKeyPrefix} />
          ) : undefined
        }
      >
        {isSelected && (
          <WithdrawalDetails
            pot={subPlan}
            maxAmount={getCurrencyFloat(subPlan.totalValue)}
          />
        )}
      </PlanAccordionShell>
    </Box>
  );
};
